module.exports = __webpack_public_path__ + "pc/img/icon1.ffee0fea.png";